<app-admin-sidebar></app-admin-sidebar>
  <div id="main" aria-label="Users page" class="content page" tabindex="-1">
    <div class="row">
      <div class="top-row">
        <div class="column">
          <h1 class="users-title" i18n="Page Title|This is the title for users page@@usersPageTitle">Users</h1>
        </div>
        <div id="adminSearch">
          <div class="row">
            <div id="inviteUsersId" class="buttons-container">
              <div id="inviteButton">
                <button class="btn btn-primary"
                        i18n="Inviting Users link|A link to the Invite Users section@@usersSearchButton"
                        routerLink="/users/invite">
                  <span class="glyphicon glyphicon-envelope" aria-hidden="true"></span> Invite Users
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="summary-table" class="summary-table">
        <div class="number-text-summary custom-tooltip" tabindex="0"
             tooltip="Users who logged in within last 12 months" i18n-tooltip placement="bottom">
          <div class="number-summary">{{ activeCount }}</div>
          <div class="text-summary" i18n="Summary Active|Summary title for active page@@usersSummaryActive">Active</div>
        </div>
        <div class="number-text-summary custom-tooltip" tabindex="0"
             tooltip="Users who have not logged in in last 12 months" i18n-tooltip placement="bottom">
          <div class="number-summary">{{ nonActiveCount }}</div>
          <div class="text-summary" i18n="Summary NonActive|Summary title for non active page@@usersSummaryNoneActive">
            Non-active
          </div>
        </div>
        <div class="vertical-line-summary"></div>
        <div class="number-text-summary custom-tooltip" tabindex="0"
             tooltip="Disabled user accounts at your institution" i18n-tooltip placement="bottom">
          <div class="number-summary">{{ deactivatedCount }}</div>
          <div class="text-summary" i18n="Summary Disabled|Summary title for disabled page@@usersSummaryDisabled">
            Disabled
          </div>
        </div>
        <div class="number-text-summary custom-tooltip" tabindex="0"
             tooltip="Enabled user accounts at your institution" i18n-tooltip placement="bottom">
          <div class="number-summary">{{ enabledUsers !== null ? enabledUsers : notAvailableText }}</div>
          <div class="text-summary" i18n="Summary Enabled|Summary title for enabled@@usersSummaryEnabled">Enabled</div>
        </div>
        <div class="vertical-line-summary"></div>
        <div class="number-text-summary custom-tooltip" tabindex="0"
             tooltip="Total number of user accounts at your institution (including both disabled and enabled accounts)" i18n-tooltip placement="bottom">
          <div class="number-summary">{{ totalCount }}</div>
          <div class="text-summary" i18n="Summary Total|Summary title for total page@@usersSummaryTotal">Total</div>
        </div>
        
        <div class="vertical-line-summary" *ngIf="seatLimit !== null"></div>
        <div class="number-text-summary custom-tooltip" tabindex="0" *ngIf="seatLimit !== null"
             tooltip="Number of users who can create accounts at your institution" i18n-tooltip placement="bottom">
          <div class="number-summary" [class.seats-exhausted]="seatsAvailable === 0">{{ seatsAvailable }}</div>
          <div class="text-summary" [class.seats-exhausted]="seatsAvailable === 0" i18n="Summary Seats Available|Summary title for seats available@@usersSummarySeatAvailable">
            Seats available
          </div>
        </div>
        <div class="number-text-summary custom-tooltip" tabindex="0" *ngIf="seatLimit !== null"
             tooltip="Number of enabled user accounts you can have at your institution" i18n-tooltip placement="bottom">
          <div class="number-summary">{{ seatLimit }}</div>
          <div class="text-summary" i18n="Summary Seat Limit|Summary title for seat limit@@usersSummarySeatLimit">
            Seat limit
          </div>
        </div>
     
        <div class="vertical-line-summary"></div>
        
        <div class="number-text-summary custom-tooltip" tabindex="0"
             tooltip="Users with Administrator privileges" i18n-tooltip placement="bottom">
          <div class="number-summary">{{ adminCount }}</div>
          <div class="text-summary" i18n="Summary Admin|Summary title for admin page@@usersSummaryAdmin">Admins</div>
        </div>
      </div>
      <ul class="nav nav-tabs">
        <li [class.active]="selectedTab === 'users'"
            i18n="Tab Title|This is the title for invited tab page@@usersPageUsersTabTitle">
          <a (click)="selectTab('users')" href="#">Users</a>
        </li>
        <li [class.active]="selectedTab === 'invited'"
            i18n="Tab Title|This is the title for users tab page@@usersPageInvitedTabTitle">
          <a (click)="selectTab('invited')" href="#">Invited</a>
        </li>
      </ul>
      <div *ngIf="selectedTab === 'users'">
        <div class="row row-height">
          <div id="actionButton">
        <span>
          <div class="btn-group" dropdown [isDisabled]="!selectedUsers.userIds.length" #bulkActionsDropdown="bs-dropdown">
           <button dropdownToggle id="bulkActions" class="btn btn-default dropdown-toggle">
               <span i18n="@@usersTableActionsButton">Actions </span>
               <span class="caret dropdown-caret" [ngClass]="{'caret-open': bulkActionsDropdown.isOpen}"></span>
            </button>
            <ul *dropdownMenu class="dropdown-menu thick" role="menu">
              <li><a class="dropdown-item" data-target="#" (click)="bulkAction('MAKE_ADMIN')"
                     i18n="@@usersActionBulkMakeAdmin">Make Admins</a></li>
              <li><a class="dropdown-item" data-target="#" (click)="bulkAction('REVOKE_ADMIN')"
                     i18n="@@usersActionBulkRemoveAdmin">Remove as Admins</a></li>
              <li class="divider" *ngIf="adminUser.discountGroup.groupSettings.strictMode"></li>
              <li *ngIf="adminUser.discountGroup.groupSettings.strictMode">
                <a class="dropdown-item" data-target="#" (click)="bulkAction('ENABLE')"
                   i18n="@@usersActionBulkReactivateUsers">Enable Users</a>
              </li>
              <li *ngIf="adminUser.discountGroup.groupSettings.strictMode">
                <a class="dropdown-item red" data-target="#" (click)="bulkAction('DISABLE')"
                   i18n="@@usersActionBulkDeactivateUsers">Disable Users</a>
              </li>
            </ul>
          </div>
        </span>
            <span class="vertical-divider"></span>
            <span>
          <div class="btn-group dropdown" dropdown #lastActiveDropdown="bs-dropdown">
            <button dropdownToggle class="btn btn-default dropdown-toggle" type="button">
              <span *ngIf="lastActiveLabel"
                    i18n="Users Time Filter|Time filter dropdown title page@@usersTimeFilterTitle">Users: {{ lastActiveLabel }}&nbsp;</span>
              <span class="caret dropdown-caret" [ngClass]="{'caret-open': lastActiveDropdown.isOpen}"></span>
            </button>
            <ul *dropdownMenu class="dropdown-menu thick" role="menu">
              <li class="dropdown-menu-item text-left users-dropdown-item" role="actionitem"
                  *ngFor="let option of Object.keys(lastActiveOptions)">
                <span class="glyphicon"
                      [ngClass]="{'glyphicon-ok': lastActiveOptions[option] == lastActiveLabel}"></span>
                <a href="javascript:void(0)" (click)="selectLastActive(option)">{{ lastActiveOptions[option] }}</a>
              </li>
            </ul>
          </div>
        </span>
            <button id="filters" [ngClass]="{'pressed': filtersVisible}" class="btn btn-default filters-button"
                    type="submit"
                    i18n="@@adminUserFilterButton" (click)="showFilters()">
              <span class="glyphicon rw-plus-thin" aria-hidden="true"></span>
              &nbsp;Filters {{ getNumFilters() > 0 ? '(' + getNumFilters() + ')' : '' }}
            </button>
            <span>&nbsp;&nbsp;</span>
            <button class="dropdown-item clear-all-label" (click)="clearAllFilters()" *ngIf="filtersChanged()"
                    i18n="@@UsersFilterClearAll">
              Clear all
            </button>
            <div class="form-group input-right">
              <div>
                <div class="spinner-margin column spinner sm spinner-input-search" *ngIf="showSpinner"></div>
                <label class="sr-only" for="email-input"
                       i18n="Email Search|Searching for user via emails@@usersLabelSearchEmail">Search by email</label>
                <div class="input-group input-search">
            <span class="input-group-addon glyphicon-background-transparent input-border-none icon-margin-bottom">
              <span class="glyphicon glyphicon-search"></span>
            </span>
                  <input class="form-control input-border-none" id="email-input"
                         i18n-placeholder="Email Address Placeholder|Placeholder text for the input@@usersPlaceholderEmail"
                         placeholder="Search by email address or name" name="emailInput" type="text"
                         [(ngModel)]="emailSearch" (input)="searchEmail()" (keyup.backspace)="handleBackspace($event)"
                         (keyup.enter)="searchOnEnter()"/>
                  <i class="close-icon" *ngIf="emailSearch.length > 0" (click)="reset()"></i>
                </div>
              </div>
              <div id="downloadButton">
                <button id="downloadUsersButton"
                        class="btn btn-default download-button custom-tooltip"
                        placement="bottom"
                        type="submit"
                        [disabled]="showCSVSpinner"
                        (click)="downloadCSVFile()">
                  <ng-container *ngIf="!showCSVSpinner">
                    <span class="glyphicon glyphicon-download-alt" aria-hidden="true"></span>
                    <span i18n="@@adminUserExportButton"> Download</span>
                  </ng-container>
                  <ng-container *ngIf="showCSVSpinner">
                    <span class="spinner-border" role="status" aria-hidden="true"></span>
                    <span i18n="@@adminUserDownloadingButtonText"> Downloading...</span>
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
          <div id="filtersSection" class="filters-section" *ngIf="filtersVisible">
          <span>
            <div class="btn-group" dropdown [outsideClick]="'disabled'" #statusDropdown="bs-dropdown">
              <button dropdownToggle id="statusFilter" class="btn btn-default dropdown-toggle">
                <span i18n="@@usersTableStatusText"> Status {{ getStatusText() }}&nbsp;</span>
                <span class="caret dropdown-caret" [ngClass]="{'caret-open': statusDropdown.isOpen}"></span>
              </button>
              <ul *dropdownMenu class="dropdown-menu thick" role="menu" (click)="$event.stopPropagation()">
                <li *ngFor="let option of statusOptions">
                  <label class="dropdown-item">
                    <input type="checkbox" [(ngModel)]="option.checked">
                    {{ option.label }}
                  </label>
                </li>
              </ul>
            </div>
          </span>
            <span>&nbsp;&nbsp;</span>
            <div class="btn-group dropdown-container" dropdown [outsideClick]="'disabled'" #roleDropdown="bs-dropdown">
              <button dropdownToggle id="roleFilter" class="btn btn-default dropdown-toggle"
                      i18n="@@adminUserFilterRole">
                Role {{ selectedRolesSummary() }}
                <span class="caret dropdown-caret" [ngClass]="{'caret-open': roleDropdown.isOpen}"></span>
              </button>
              <ul *dropdownMenu class="dropdown-menu thick" role="menu" (click)="$event.stopPropagation()">
                <li *ngFor="let option of roleOptions">
                  <label class="dropdown-item">
                    <input type="checkbox" [indeterminate]="option.label === 'All' ? isRoleIndeterminate : false"
                           [ngModel]="option.checked" (ngModelChange)="onRoleOptionChange($event, option)">
                    {{ option.label }}
                  </label>
                </li>
              </ul>
            </div>
            <span>&nbsp;&nbsp;</span>
            <span>
            <div class="btn-group dropdown-container" dropdown [outsideClick]="'disabled'" *ngIf="areaOptions.length>1" #areaDropdown="bs-dropdown">
              <button dropdownToggle id="areaFilter" class="btn btn-default dropdown-toggle"
                      i18n="@@adminUserFilterAoF">
                Area of focus {{ selectedAreaSummary() }}
                <span class="caret dropdown-caret" [ngClass]="{'caret-open': areaDropdown.isOpen}"></span>
              </button>
              <ul *dropdownMenu class="dropdown-menu thick" role="menu" (click)="$event.stopPropagation()">
              <li *ngFor="let option of areaOptions">
                  <label class="dropdown-item">
                    <input type="checkbox" [indeterminate]="option.label === 'All' ? isAreaIndeterminate : false"
                           [(ngModel)]="option.checked" (ngModelChange)="onAreaOptionChange($event, option)">
                    {{ option.label }}
                  </label>
                </li>
              </ul>
            </div>
          </span>
            <span>&nbsp;&nbsp;</span>
            <span>
            <div class="btn-group dropdown-container" dropdown *ngIf="showAdditionalProfileInformation"
                 #additionalDropdown="bs-dropdown"
                 [outsideClick]="'disabled'">
              <button dropdownToggle id="additionalFilter" class="btn btn-default dropdown-toggle">
                {{ additionalProfileInformationLabel + selectedAdditionalSummary() }}
                <span class="caret dropdown-caret" [ngClass]="{'caret-open': additionalDropdown.isOpen}"></span>
              </button>
              <ul *dropdownMenu class="dropdown-menu thick" role="menu" (click)="$event.stopPropagation()">
                <li *ngFor="let option of additionalOptions">
                  <label class="dropdown-item">
                    <input type="checkbox" [indeterminate]="option.label === 'All' ? isAdditionalIndeterminate : false"
                           [(ngModel)]="option.checked" (ngModelChange)="onAdditionalOptionChange($event, option)">
                    {{ option.label }}
                  </label>
                </li>
              </ul>
            </div>
          </span>
            <span>&nbsp;&nbsp;</span>
            <label i18n="@@adminUserFilterAdminOnly">
              <input type="checkbox" class="custom-checkbox" (change)="onAdminOnlyChange()" [checked]="adminOnly">
              Admin only
            </label>
            <span>&nbsp;&nbsp;</span>
            <button class="btn btn-primary" (click)="applyFilters()" [disabled]="!filtersChanged()"
                    i18n="@@adminUserFilterApply">
              <span aria-hidden="true"></span> Apply filters
            </button>
          </div>
          <div class="row excel-message" *ngIf="isCJKLanguage()">
            <div class="row"><label class="row" i18n="@@excelMessageLabel">To properly display the characters in
              excel,</label></div>
            <div class="row"><a class="row excel-message-link" id="excelSolutionLink" i18n="@@excelMessageLink"
                                href="https://excel.officetuts.net/en/examples/how-to-import-csv-file-that-uses-utf-8-encoding"
                                target="_blank">import the CSV file with Unicode: UTF-8 encoding.</a></div>
          </div>
          <div class="table-container">
            <table class="table users custom-table" id="users" (scroll)="updateMargins()" (window:resize)="onResize()">
              <thead>
              <tr>
                <th class="fixed-left-first">
                  <span>
                    <input type="checkbox" id="toggleAllUsers" [(ngModel)]="selectedUsers.allUsersOnPage"
                           [indeterminate]="isIndeterminateUsers" (change)="toggleSelectAllUsersOnPage()"/>
                  </span>
                </th>
                <th class="sort-indicator fixed-left-second" i18n="Email|Users Email address@@usersTableHeaderEmail"
                    (click)="sortTable('email')">
                  Email
                  <span class="uxf-icon uxf-arrow-combo" [ngClass]="{'uxf-up-caret': currentSortField === 'email' && currentSortType === 'ASC',
                  'uxf-down-caret': currentSortField === 'email' && currentSortType === 'DESC'}"
                        (keydown)="handleCaretKey($event, 'email')" role="button" tabindex="0"></span>
                </th>
                <th i18n="Name|User Name@@usersTableHeaderName" class="sort-indicator fixed-left-third"
                    (click)="sortTable('firstName')">
                  Name
                  <span class="uxf-icon uxf-arrow-combo" [ngClass]="{'uxf-up-caret': currentSortField === 'firstName' && currentSortType === 'ASC',
                  'uxf-down-caret': currentSortField === 'firstName' && currentSortType === 'DESC'}"
                        (keydown)="handleCaretKey($event, 'firstName')" role="button" tabindex="0"></span>
                </th>
                <th class="sort-indicator" i18n="Status|Users Status@@usersTableHeaderStatus"
                    (click)="sortTable('disabled')">
                  Status
                  <span class="uxf-icon uxf-arrow-combo" [ngClass]="{'uxf-up-caret': currentSortField === 'disabled' && currentSortType === 'ASC',
                  'uxf-down-caret': currentSortField === 'disabled' && currentSortType === 'DESC'}"
                        (keydown)="handleCaretKey($event, 'disabled')" role="button" tabindex="0"></span>
                </th>
                <th class="sort-indicator" i18n="Last Active|Users Last Active@@usersTableHeaderActivity"
                    (click)="sortTable('lastActive')">
                  Last active
                  <span class="uxf-icon uxf-arrow-combo" [ngClass]="{'uxf-up-caret': currentSortField === 'lastActive' && currentSortType === 'ASC',
                  'uxf-down-caret': currentSortField === 'lastActive' && currentSortType === 'DESC'}"
                        (keydown)="handleCaretKey($event, 'lastActive')" role="button" tabindex="0"></span>
                </th>
                <th class="sort-indicator" i18n="Expiration date|Users Expiration date@@usersTableHeaderActivity"
                    *ngIf="isIndividualInstitution" (click)="sortTable('expirationDate')">
                  Expiration date
                  <span class="uxf-icon uxf-arrow-combo" [ngClass]="{'uxf-up-caret': currentSortField === 'expirationDate' && currentSortType === 'ASC',
                  'uxf-down-caret': currentSortField === 'expirationDate' && currentSortType === 'DESC'}"
                        (keydown)="handleCaretKey($event, 'expirationDate|')" role="button" tabindex="0"></span>
                </th>
                <th class="sort-indicator" i18n="Role|Users Role@@usersTableHeaderRole" (click)="sortTable('role')">
                  Role
                  <span class="uxf-icon uxf-arrow-combo" [ngClass]="{'uxf-up-caret': currentSortField === 'role' && currentSortType === 'ASC',
                  'uxf-down-caret': currentSortField === 'role' && currentSortType === 'DESC'}"
                        (keydown)="handleCaretKey($event, 'role')" role="button" tabindex="0"></span>
                </th>
                <th class="auto-width column-numbers-center"
                    i18n="No of Folders|Users No of Folders@@usersTableHeaderFolders">Folders
                </th>
                <th class="auto-width column-numbers-center"
                    i18n="No of References|Users No of References@@usersTableHeaderReferences">References
                </th>
                <th class="auto-width column-numbers-center"
                    i18n="No of Projects|Users No of Projects@@usersTableHeaderProjects">Projects
                </th>
                <th class="sort-indicator"
                    [ngClass]="{'auto-width': showAdditionalProfileInformation, 'custom-th-with': !showAdditionalProfileInformation}"
                    i18n="Area Of Focus|Users No of Projects@@usersTableHeaderAoF" (click)="sortTable('areaOfFocus')">
                  Area of Focus
                  <span class="uxf-icon uxf-arrow-combo" [ngClass]="{'uxf-up-caret': currentSortField === 'areaOfFocus' && currentSortType === 'ASC',
                  'uxf-down-caret': currentSortField === 'areaOfFocus' && currentSortType === 'DESC'}"
                        (keydown)="handleCaretKey($event, 'areaOfFocus')" role="button" tabindex="0"></span>
                </th>
                <th *ngIf="showAdditionalProfileInformation" class="sort-indicator auto-width"
                    i18n="AccountProfile|Users AccountProfile@@usersTableHeaderAdditional"
                    (click)="sortTable('institutionAnswer')">
                  Additional Profile Information
                  <span class="uxf-icon uxf-arrow-combo" [ngClass]="{'uxf-up-caret': currentSortField === 'institutionAnswer' && currentSortType === 'ASC',
                  'uxf-down-caret': currentSortField === 'institutionAnswer' && currentSortType === 'DESC'}"
                        (keydown)="handleCaretKey($event, 'institutionAnswer')" role="button" tabindex="0"></span>
                </th>
                <th class="td-actions fixed-right"></th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let data of users; let i = index" [ngClass]="{'expired': isUserExpired(data.user.expirationDate)}">
                <td class="fixed-left-first"><input *ngIf="(hasActions(data.user))" type="checkbox" class="selection"
                                                    [(ngModel)]="data.user.selected"
                                                    (change)="toggleSingleUser(data.user.id)"/></td>
                <td class="ellipsis fixed-left-second">{{ data.user.email }}</td>
                <td class="ellipsis td-nowrap fixed-left-third">{{ data.user.firstName + ' ' + data.user.lastName }}
                </td>
                <td class="user-status">
              <span>
                {{ getUserStatusText(data.user) }}
              </span>
                </td>
                <td>{{ data.user.lastActive | date:'MMMM d, yyyy' }}</td>
                <td *ngIf="isIndividualInstitution">{{ data.user.expirationDate | date:'MMMM d, yyyy' }}</td>
                <td>{{ data.user.role }}</td>
                <td class="numbers otro-elemento">{{ data.numOfFolders ? data.numOfFolders : 0 }}</td>
                <td class="numbers otro-elemento">{{ data.numOfReferences ? data.numOfReferences : 0 }}</td>
                <td class="numbers otro-elemento">{{ data.numOfProjects ? data.numOfProjects : 0 }}</td>
                <td class="td-nowrap">{{ data.user.areaOfFocus }}</td>
                <td *ngIf="showAdditionalProfileInformation" class="td-nowrap">{{ data.user.institutionAnswer }}</td>
                <td class="td-actions fixed-right" #dropdownParent>
                  <div class="dropdown-container" *ngIf="(hasActions(data.user)) ? 'disabled' : ''">
                    <!-- The following onShown and onHidden events are firefox hacks.
                         If you see this and firefox 121 is already out, please try removing them.-->
                    <div class="btn-group" dropdown [dropup]="i && i >= users.length-3" #dropdown="bs-dropdown"
                         *ngIf="hasActions(data.user)" placement="bottom right"
                         (onShown)="dropdownParent.setAttribute('style', 'z-index: 1000')"
                         (onHidden)="dropdownParent.setAttribute('style', 'z-index: 100')">
                      <button dropdownToggle [ngClass]="{'pressed': dropdown.isOpen}"
                              class="actions-dropdown-button glyphicon glyphicon-option-vertical"
                              type="button"></button>
                      <ul *dropdownMenu class="dropdown-menu thick-tooltip dropdown-menu-right custom-dropdown-menu"
                          [ngClass]="{'dropup-menu-right': i && i >= users.length-3}" role="menu" placement="left">
                        <li class="dropdown-menu-item text-left" role="actionitem"
                            *ngIf="!data.user.isInstitutionAdmin">
                          <a (click)="singleAction(data.user, 'admin')" href="javascript:void(0)"
                             i18n="Make Admin|Granting the User Admin Rights@@usersTableGrantAdminButton">Make Admin</a>
                        </li>
                        <li class="dropdown-menu-item text-left" role="actionitem" *ngIf="data.user.isInstitutionAdmin">
                          <a (click)="singleAction(data.user, 'remove')" href="javascript:void(0)"
                             i18n="Revoke Admin|Revoking Admin Rights@@usersTableRemoveAdminButton">Remove as Admin</a>
                        </li>
                        <li class="divider"></li>
                        <li class="dropdown-menu-item text-left" role="actionitem"
                            *ngIf="adminUser.discountGroup.groupSettings.strictMode && (getUserStatusText(data.user) === 'Enabled' || getUserStatusText(data.user) === 'Enabled/Admin')">
                          <a class="red" (click)="singleAction(data.user, 'disable')"
                             i18n="@@settingsDeactivateUserText" href="javascript:void(0)">Disable
                            User</a>
                        </li>
                        <li class="dropdown-menu-item text-right" role="actionitem"
                            *ngIf="adminUser.discountGroup.groupSettings.strictMode && (getUserStatusText(data.user) === 'Disabled' || getUserStatusText(data.user) === 'Disabled/Admin')">
                          <a (click)="singleAction(data.user, 'enable')" i18n="@@settingsReactivateText"
                             href="javascript:void(0)">Enable User</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <p class="not-found" *ngIf="!users.length">
            No users found.
          </p>
          <div class="pull-right text-muted" id="pagination" *ngIf="users.length">
            <nav class="pull-right" aria-label="Page navigation" *ngIf="totalCountOfUsers > pageSize">
              <ul class="pagination">
                <li [ngClass]="{'disabled':start < 1}">
                  <a href="#" aria-label="Previous" (click)="previousPage()"><span aria-hidden="true"><</span></a>
                </li>
                <li [ngClass]="{'disabled':end >= totalCountOfUsers}">
                  <a href="#" aria-label="Next" (click)="nextPage()"><span aria-hidden="true">></span></a>
                </li>
              </ul>
            </nav>
            <div class="pagination-container">
              <div class="pagination-dropdown">
                <select class="custom-dropdown" tabindex="0" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
                  <option *ngFor="let option of pageSizeOptions" [ngValue]="option"
                          i18n="@@usersTablePerPage">{{ option }} per page
                  </option>
                </select>
              </div>
              <div class="pull-right" id="pagination-info" i18n="@@usersTablePage">
                <strong>{{ start + 1 }}</strong> - <strong>{{ end }}</strong> of
                <strong>{{ totalCountOfUsers }}</strong> users
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="selectedTab === 'invited'">
        <app-invited></app-invited>
      </div>
      <ng-template #userStatusErrorTemplate="">
        <i class="uxf-icon uxf-close"></i><span
        i18n="Unable to Set Status|Message when the user status cannot be set@@usersMessageSetStatusError">Unable to set user status, please try again.</span>
      </ng-template>
      <ng-template #toggleAdminErrorTemplate="">
        <i class="uxf-icon uxf-close"></i><span
        i18n="Unable to Change Admin Status|Message when the user admin status cannot be set@@usersMessageChangeAdminError">Unable to change admin status, please try again.</span>
      </ng-template>
      <span class="hidden" #toasterSuccessGrantAdmin i18n="@@adminUserAddAdminSuccess">Admin created successfully. To remove a user as an admin, select Actions > Remove as Admin.</span>
      <span class="hidden" #toasterSuccessRemoveAdmin i18n="@@adminUserRemoveAdminSuccess">User removed as admin. To add a user as an admin, select Actions > Make Admin.</span>
      <span class="hidden" #toasterSuccessDeactivateUser i18n="@@adminUserDeactivateSuccess">Account Disabled. To enable a user, select Actions > Enable User.</span>
      <span class="hidden" #toasterSuccessReactivateUser i18n="@@adminUserReactivateSuccess">Account Enabled. To disable a user, select Actions > Disable User.</span>

      <span class="hidden" #toasterSuccessGrantAdminBulk i18n="@@adminUserAddAdminSuccessBulk">Admins created successfully. To remove a user as an admin, select Actions > Remove as Admin.</span>
      <span class="hidden" #toasterSuccessRemoveAdminBulk i18n="@@adminUserRemoveAdminSuccessBulk">Users removed as admins. To add a user as an admin, select Actions > Make Admin.</span>
      <span class="hidden" #toasterSuccessDeactivateUserBulk i18n="@@adminUserDeactivateSuccessBulk">Accounts Disabled. To enable a user, select Actions > Enable User.</span>
      <span class="hidden" #toasterSuccessReactivateUserBulk i18n="@@adminUserReactivateSuccessBulk">Accounts Enabled. To disable a user, select Actions > Disable User.</span>

      <span class="hidden" #toasterFailGrantAdmin i18n="@@adminUserAddAdminFail">Unable to create admin. If the problem persists, please contact your administrator.</span>
      <span class="hidden" #toasterFailRemoveAdmin i18n="@@adminUserRemoveAdminFail">Unable to remove user as admin. If the problem persists, please contact your administrator.</span>
      <span class="hidden" #toasterFailDeactivateUser i18n="@@adminUserDeactivateFail">Unable to deactivate user. If the problem persists, please contact your administrator.</span>
      <span class="hidden" #toasterFailReactivateUser i18n="@@adminUserReactivateFail">Unable to reactivate user. If the problem persists, please contact your administrator.</span>

      <span class="hidden" #toasterFailGrantAdminBulk i18n="@@adminUserAddAdminFailBulk">Unable to create admins. If the problem persists, please contact your administrator.</span>
      <span class="hidden" #toasterFailRemoveAdminBulk i18n="@@adminUserRemoveAdminFailBulk">Unable to remove users as admin. If the problem persists, please contact your administrator.</span>
      <span class="hidden" #toasterFailDeactivateUserBulk i18n="@@adminUserDeactivateFailBulk">Unable to deactivate users. If the problem persists, please contact your administrator.</span>
      <span class="hidden" #toasterFailReactivateUserBulk i18n="@@adminUserReactivateFailBulk">Unable to reactivate users. If the problem persists, please contact your administrator.</span>

      <span class="hidden" #toasterActionUndoneSuccess
            i18n="@@adminUserActionUndoneSuccess">Your action has been undone.</span>
      <app-admin-modal-component (modalResponse)="handleResponse($event)"></app-admin-modal-component>
    </div>
